export interface KeyboardNavigationListenerHandle {
    detach(): void;
}

export function attachKeyboardNavigationKeydownListener(
    root: HTMLElement,
    onKeydown: (event: KeyboardEvent) => void,
): KeyboardNavigationListenerHandle {
    root.addEventListener("keydown", onKeydown);

    return {
        detach(): void {
            root.removeEventListener("keydown", onKeydown);
        },
    };
}
